// hooks/useMenuData.js
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { APPBAR_MENU } from "../constant/constant";
import { accessibleMenus } from "../helper/com-helper";
import { useRuntimeContextVersion } from "./useRuntimeContextVersion";
import { APP_MENU, BAR_MENU } from "../utils/const";
import { ROUTES_PATH } from "../utils/EndPoints";
import { PROFILE_ROUTE } from "../utils/RouteHelper/SCAI";
import { Setup } from "../assets/svg-icons";
import { ENUM_EVENT } from "../utils/eventEmitter";

// Custom hook to manage and fetch menu data
const useMenuData = (selectedMenu) => {
  const location = useLocation();
  const [menuData, setMenuData] = useState({
    parent: [],
    menu: [],
    subMenu: [],
    footer:[]
  });
  const [customEntityVersion, setCustomEntityVersion] = useState(0);
  // accessibleMenus() below reads permissions off appState — a plain
  // mutable snapshot, not React state — which only finishes populating
  // asynchronously after a refresh (AuthContext's refresh()). Without this,
  // the effect below computes an empty/stale menu once at mount and never
  // recomputes until something else (e.g. a nav click changing
  // location.pathname) happens to re-trigger it.
  const runtimeVersion = useRuntimeContextVersion();

  useEffect(() => {
    const handler = () => setCustomEntityVersion((v) => v + 1);
    globalThis.addEventListener(ENUM_EVENT.CUSTOM_ENTITY_UPDATED, handler);
    return () => globalThis.removeEventListener(ENUM_EVENT.CUSTOM_ENTITY_UPDATED, handler);
  }, []);

  useEffect(() => {
    const parentMenu =
      selectedMenu?.parent === APPBAR_MENU?.ID
        ? []
        : accessibleMenus(Object.values(BAR_MENU));
    const selectedBarMenu = BAR_MENU?.[APP_MENU?.[selectedMenu?.parent]];

    const _mainMenu = selectedBarMenu?.child ?? {};
    const mainMenuItems =
      location?.pathname === ROUTES_PATH.MY_PROFILE
        ? PROFILE_ROUTE
        : accessibleMenus(Object.values(_mainMenu));

    const selectedMenuChild = _mainMenu[selectedMenu?.menu]?.child ?? {};
    const subMenuItems = accessibleMenus(Object.values(selectedMenuChild));
    const footerMenus =
      selectedMenu?.parent === APPBAR_MENU?.IBP
        ? accessibleMenus([
            {
              name: "Setup",
              shortName: "Setup",
              icon: Setup,
              route: "/snop/setup",
              permissions: ["SNOP_VIEW"],
            },
          ])
        : [];

    setMenuData({
      parent: parentMenu,
      menu: mainMenuItems,
      subMenu: subMenuItems,
      footer: footerMenus
    });
  }, [selectedMenu, accessibleMenus, customEntityVersion, runtimeVersion, location.pathname]);

  return menuData;
};

export default useMenuData;
